//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'rut',
        format: 'rut',
    },
    {
        text: 'nombre(s)',
        value: 'names',
    },
    {
        text: 'primer apellido',
        value: 'last_name1',
    },
    {
        text: 'segundo apellido',
        value: 'last_name2',
    },
    {
        text: 'correo electrónico',
        value: 'email',
    },
    {
        text: 'prevision',
        value: 'hr_prevision_name',
        component: {
            type: 'chip',
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: 'black',
            },
        },
    },
    {
        text: 'contrato activo',
        value: 'active_contract',
        align: 'center',
        format: 'boolean',
    },
]
